"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
interface DecisionRow {
  situation: string;
  recommendation: string;
  to: string;
}
const decisionRows: DecisionRow[] = [{
  situation: "Pain or a new injury",
  recommendation: "Start with Physiotherapy",
  to: "/ExpertPhysiotherapyPage"
}, {
  situation: "Muscular tension or recovery",
  recommendation: "Choose Sports & Recovery Massage",
  to: "/RecoveryMassagePage"
}, {
  situation: "Walking, gait or balance concerns",
  recommendation: "Choose Gait & Balance Assessment",
  to: "/GaitBalanceAssessmentPage"
}, {
  situation: "Considering custom insoles",
  recommendation: "Explore Custom Orthotics",
  to: "/Custom3DPrintedOrthoticsPage"
}, {
  situation: "More specialist movement analysis",
  recommendation: "Contact us about Biomechanics",
  to: "/BiomechanicsExpertisePage"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: [0.25, 0.1, 0.25, 1.0]
    }
  }
};
export default function DecisionGuide() {
  return <section id="decisionguide" data-nav="light" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight">
            Not sure which appointment you need?
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="flex flex-col gap-3.5">
          {decisionRows.map((row, i) => <motion.div key={row.situation} variants={itemVariants} data-index={i}>
              <Link to={row.to} className="group flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-5 md:px-6 md:py-5 rounded-xl border border-border bg-card text-card-foreground shadow-2xs hover:shadow-sm hover:border-primary/40 transition-all duration-200">
                <span className="text-base md:text-lg font-medium text-foreground group-hover:text-primary transition-colors">
                  {row.situation}
                </span>

                <div className="flex items-center gap-2 self-end sm:self-auto shrink-0 font-medium text-sm md:text-base text-chart-2">
                  <span>{row.recommendation}</span>
                  <ArrowRight className="size-4.5 transition-transform duration-200 group-hover:translate-x-1" />
                </div>
              </Link>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} className="mt-10 md:mt-12 text-center flex flex-col items-center gap-5">
          <p className="text-muted-foreground text-sm md:text-base max-w-xl">
            If you are unsure, contact us before booking, and we can help you identify the most appropriate starting point.
          </p>
          <Button asChild size="lg" className="rounded-md">
            <Link to="/ContactPage">Contact PhysAnalytica</Link>
          </Button>
        </motion.div>
      </div>
    </section>;
}